import PrimaryMessageHeaderContent from '../primary-message/components/PrimaryMessageHeaderContent';
import MessageHeaderTimestamp from '../common-message-header/MessageHeaderTimestamp';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderWrapper = ({
  title,
  detail,
  detailsPopover,
  timestamp,
  actions,
  channel
}) => {
  var _title$componentProps;
  const TitleComponent = (title === null || title === void 0 ? void 0 : title.Component) || FormattedMessage;
  const DetailComponent = detail === null || detail === void 0 ? void 0 : detail.Component;
  const ChannelComponent = channel === null || channel === void 0 ? void 0 : channel.Component;
  const DetailsPopoverComponent = detailsPopover === null || detailsPopover === void 0 ? void 0 : detailsPopover.Component;
  const TimestampComponent = timestamp === null || timestamp === void 0 ? void 0 : timestamp.Component;
  const ActionsComponent = actions === null || actions === void 0 ? void 0 : actions.Component;
  return /*#__PURE__*/_jsxs(PrimaryMessageHeaderContent, {
    children: [/*#__PURE__*/_jsx(Text, {
      as: "strong",
      typography: "heading-25",
      children: /*#__PURE__*/_jsxs(Flex, {
        id: "title-detail-container",
        alignItems: "center",
        children: [title && /*#__PURE__*/_jsx(View, Object.assign({
          marginInlineEnd: "100",
          as: "span"
        }, (_title$componentProps = title.componentProps) !== null && _title$componentProps !== void 0 && _title$componentProps['data-test-id'] ? {
          'data-test-id': title.componentProps['data-test-id']
        } : {}, {
          children: title.isLoading ? /*#__PURE__*/_jsx(SkeletonText, Object.assign({
            inlineSize: "150px"
          }, title === null || title === void 0 ? void 0 : title.loaderProps)) : title.renderCustom ? title.renderCustom({
            Component: FormattedMessage
          }) : ((title === null || title === void 0 ? void 0 : title.Component) || (title === null || title === void 0 ? void 0 : title.componentProps)) && /*#__PURE__*/_jsx(TitleComponent, Object.assign({}, title === null || title === void 0 ? void 0 : title.componentProps))
        })), detail && /*#__PURE__*/_jsx(Text, {
          as: "span",
          "aria-hidden": "true",
          marginInline: "50",
          color: "text-core-subtle",
          typography: "detail-100",
          children: detail.renderCustom ? detail.renderCustom() : DetailComponent && /*#__PURE__*/_jsx(DetailComponent, Object.assign({}, detail === null || detail === void 0 ? void 0 : detail.componentProps))
        }), channel && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            as: "span",
            "aria-hidden": "true",
            marginInline: "50",
            color: "text-core-subtle",
            typography: "detail-100",
            children: `•`
          }), /*#__PURE__*/_jsx(Text, {
            as: "span",
            marginInlineStart: "50",
            color: "text-core-subtle",
            typography: "detail-100",
            children: channel.renderCustom ? channel.renderCustom() : ChannelComponent && /*#__PURE__*/_jsx(ChannelComponent, Object.assign({}, channel === null || channel === void 0 ? void 0 : channel.componentProps))
          })]
        }), detailsPopover !== null && detailsPopover !== void 0 && detailsPopover.renderCustom ? detailsPopover.renderCustom() : DetailsPopoverComponent && /*#__PURE__*/_jsx(DetailsPopoverComponent, Object.assign({}, detailsPopover === null || detailsPopover === void 0 ? void 0 : detailsPopover.componentProps))]
      })
    }), timestamp && /*#__PURE__*/_jsx(Flex, {
      as: "span",
      flexDirection: "row",
      alignItems: "center",
      marginInlineStart: "auto",
      children: timestamp.renderCustom ? timestamp.renderCustom({
        Component: MessageHeaderTimestamp
      }) : TimestampComponent ? /*#__PURE__*/_jsx(TimestampComponent, Object.assign({}, timestamp === null || timestamp === void 0 ? void 0 : timestamp.componentProps)) : timestamp.componentProps && /*#__PURE__*/_jsx(MessageHeaderTimestamp, Object.assign({}, timestamp.componentProps))
    }), actions && actions.renderCustom ? actions.renderCustom() : ActionsComponent ? /*#__PURE__*/_jsx(ActionsComponent, Object.assign({}, actions === null || actions === void 0 ? void 0 : actions.componentProps)) : null]
  });
};
HeaderWrapper.displayName = 'HeaderWrapper';
export default HeaderWrapper;